import React from 'react';
import type { ImageData } from '../types';

interface Props {
    image: ImageData;
    alt: string;
    className?: string;
    sizes?: string;
}

export function LogoImage({ image, alt, className, sizes }: Props) {
    return (
        <picture>
            {image.avif && <source srcSet={image.avif} type="image/avif" sizes={sizes} />}
            {image.webp && <source srcSet={image.webp} type="image/webp" sizes={sizes} />}
            {image.jpeg && <source srcSet={image.jpeg} type="image/jpeg" sizes={sizes} />}
            <img
                src={image.fallback ?? undefined}
                alt={image.alt ?? alt}
                className={className}
                sizes={sizes}
            />
        </picture>
    );
}
